function getDaysTexts(t: Function) {
  return [
    t("gantt.monday"),
    t("gantt.tuesday"),
    t("gantt.wednesday"),
    t("gantt.thursday"),
    t("gantt.friday"),
    t("gantt.saturday"),
    t("gantt.sunday"),
  ];
}

export { getDaysTexts };
